import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { AuthProvider } from './context/AuthContext';
import App from './App';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

const theme = createTheme({
  primaryColor: 'teal',
  colors: {
    teal: [
      '#e6f3f3',
      '#cce7e8',
      '#99cfd1',
      '#66b7ba',
      '#339fa3',
      '#205357',
      '#1a444a',
      '#14353c',
      '#0d262e',
      '#071720'
    ]
  },
  fontFamily: "'Titillium Web', -apple-system, BlinkMacSystemFont, sans-serif",
  defaultRadius: 'md',
  components: {
    Button: {
      defaultProps: {
        size: 'sm'
      }
    },
    TextInput: {
      defaultProps: {
        size: 'sm'
      }
    },
    Select: {
      defaultProps: {
        size: 'sm'
      }
    },
    NumberInput: {
      defaultProps: {
        size: 'sm'
      }
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <Notifications position="top-right" />
        <AuthProvider>
          <App />
        </AuthProvider>
      </MantineProvider>
    </BrowserRouter>
  </React.StrictMode>
);
